import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { DirectiveModule } from '@fcom/common/directives';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { ServiceFormsModule } from '@fcom/service-forms';
import { CommonServiceFormsModule } from '@fcom/service-forms/components/common/common-service-forms.module';

import { ProfileService } from './services/profile.service';
import { TwoFactorAuthService } from './services/two-factor-auth.service';
import { LoyaltyMailingAddressFormComponent } from './components/loyalty-mailing-address-form/loyalty-mailing-address-form.component';
import { LoyaltyPersonalInfoFormComponent } from './components/loyalty-personal-information-form/loyalty-personal-information-form.component';
import { LoyaltyTwoFactorAuthToggleComponent } from './components/loyalty-two-factor-auth-toggle/loyalty-two-factor-auth-toggle.component';
import { LoyaltyPassportFormComponent } from './components/loyalty-passport-information-form/loyalty-passport-information-form.component';
import { LoyaltyPaymentCardsComponent } from './components/loyalty-payment-cards/loyalty-payment-cards.component';
import { LoyaltyTravelProfileFormComponent } from './components/loyalty-travel-profile-form/loyalty-travel-profile-form.component';
import { DirectMarketingPreferencesFormComponent } from './components/direct-marketing-preferences-form/direct-marketing-preferences-form.component';
import { CmsModule } from '../cms';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    GtmModule,
    PipesModule,
    CommonServiceFormsModule,
    ServiceFormsModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    UiTranslateModule,
    UiComponentsModule,
    CmsModule,
  ],
  declarations: [
    DirectMarketingPreferencesFormComponent,
    LoyaltyMailingAddressFormComponent,
    LoyaltyPersonalInfoFormComponent,
    LoyaltyTwoFactorAuthToggleComponent,
    LoyaltyPassportFormComponent,
    LoyaltyPaymentCardsComponent,
    LoyaltyTravelProfileFormComponent,
  ],
  exports: [
    DirectMarketingPreferencesFormComponent,
    LoyaltyMailingAddressFormComponent,
    LoyaltyPersonalInfoFormComponent,
    LoyaltyTwoFactorAuthToggleComponent,
    LoyaltyPassportFormComponent,
    LoyaltyPaymentCardsComponent,
    LoyaltyTravelProfileFormComponent,
  ],
  providers: [ProfileService, TwoFactorAuthService],
})
export class ProfileModule {}
